// extracted by mini-css-extract-plugin
module.exports = {"visually-hidden":"gat-light_visually-hidden__n4ZEz","gat-light":"gat-light_gat-light___uxLy"};